export default __webpack_public_path__ + "static/media/cards_shuffle.61a26af6.mp3";